import { render } from "./CreateSessionPage.vue?vue&type=template&id=7332dbdd&ts=true"
import script from "./CreateSessionPage.vue?vue&type=script&lang=ts"
export * from "./CreateSessionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__